import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, ResponsiveX, ZMath } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XDiv, XImage, XText } from "IZOX/_X";
import _ from "lodash";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class Compen extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Compen.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  renderCard(o, i){
    let {title, content, amount, icon} = o;
    return (
      <VStack height={292} round={20} pV={16} pH={22} spacing={16} VAlign="-" key={i}
        bgColor={ColorX.CSS("pureWhite")} fullWidth 
        >
        <HStack HAlign="[">
          <XImage source={icon} width={76} height={76}/>
        </HStack>
        <VStack fullWidth>
          <HStack>
            <XText fontSize={16} fullWidth textAlign="[" bold 
              color={ColorX.CSS("Grass")}            
              style={{fontWeight: 700}}>
              {LocaleX.Parse(title)}
            </XText>
          </HStack>
          <HStack HAlign="[">
            <XDiv height={1} width={100} bgColor={ColorX.CSS("Yolk")}/>
          </HStack>
        </VStack>
        <HStack fullWidth>
          <XText height={50} fullWidth textAlign="[" fontSize={14} style={{fontWeight: 400}}>
            {LocaleX.Parse(content)}
          </XText>
        </HStack>
        <HStack HAlign="[" spacing={5}>
          <XText fontSize={12} color={ColorX.CSS("Grass")}>
            {LocaleX.Parse({
              EN: "Up to",
              TC: "最高可達"
            })}
          </XText>
          <XText fontSize={22} color={ColorX.CSS("Leaf")} style={{fontWeight: 700}}>
            {"HK$" + ZMath.NumberWithCommas(amount)}
          </XText>
          <XText fontSize={12} color={ColorX.CSS("Grass")}>
            {LocaleX.Parse({
              EN: "/year",
              TC: "/年"
            })}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderSlide(){
    let {info} = this.props;
    let {compensation} = info ?? {};
    return (
      <HStack spacing={20} width={SysConfig.ContentWidth} pH={160} style={{zIndex: 10}}>
        <HStack style={{flexGrow: 1}} spacing={24}>
          {_.map(compensation, (o, i) => {
            if(o){
              return this.renderCard(o, i);
            }
          })}
        </HStack>
      </HStack>
    );
  }

  renderNormal(){
    return (
      <VStack pV={80} bgColor={ColorX.CSS("Grass")} height={450} fullWidth
        style={{position: "relative"}} mB={80}>
        <XDiv position="absolute" style={{top: 60, left: 0, marginLeft: -80, zIndex: 1, opacity: 0.1}} 
          height={387} fullWidth>
          <XImage source="/Images/home/sq2.svg" noResize width={70} height={70}
            position="absolute" style={{top: 10, left: 150}}/>
          <XImage source="/Images/home/sq1.svg" noResize width={210} height={210}
            position="absolute" style={{top: 60, left: 30}}/>
          <XImage source="/Images/home/sq1.svg" noResize width={210} height={210}
            position="absolute" style={{top: 60, left: 130}}/>
          <XImage source="/Images/home/sq2.svg" noResize width={70} height={70}
            position="absolute" style={{top: 250, left: 150}}/> 
        </XDiv>
        {this.renderSlide()}
      </VStack>
    );
  }

  renderCardM(o, i){
    let {title, content, amount, icon} = o;
    return (
      <VStack round={20} pV={16} pH={22} spacing={16} VAlign="-" key={i}
        width={window.innerWidth * 0.7}
        bgColor={ColorX.CSS("pureWhite")} 
        >
        <HStack HAlign="[" spacing={16}>
          <XImage source={icon} width={40} height={40} flexShrink={0}/>
          <VStack fullWidth>
            <HStack>
              <XText fontSize={18} fullWidth textAlign="[" bold 
                color={ColorX.CSS("Grass")}            
                style={{fontWeight: 700}}>
                {LocaleX.Parse(title)}
              </XText>
            </HStack>
            <HStack HAlign="[">
              <XDiv height={2} width={100} bgColor={ColorX.CSS("Yolk")}/>
            </HStack>
          </VStack>
        </HStack>
        <HStack fullWidth>
          <XText height={50} fullWidth textAlign="[" fontSize={16} style={{fontWeight: 400}}>
            {LocaleX.Parse(content)}
          </XText>
        </HStack>
        <VStack HAlign="[" spacing={5} fullWidth>
          <XText fontSize={14} color={ColorX.CSS("Grass")}>
            {LocaleX.Parse({
              EN: "Up to",
              TC: "最高可達"
            })}
          </XText>
          <HStack spacing={10} HAlign="[">
            <XText fontSize={22} color={ColorX.CSS("Leaf")} style={{fontWeight: 700}}>
              {"HK$" + ZMath.NumberWithCommas(amount)}
            </XText>
            <XText fontSize={14} color={ColorX.CSS("Grass")}>
              {LocaleX.Parse({
                EN: "/year",
                TC: "/年"
              })}
            </XText>
          </HStack>
        </VStack>
      </VStack>
    );
  }

  renderSlideM(){
    let {info} = this.props;
    let {compensation} = info ?? {};
    return (
      <VStack spacing={20} fullWidth zIndex={10}>
        <VStack spacing={24}>
          {_.map(compensation, (o, i) => {
            if(o){
              return this.renderCardM(o, i);
            }
          })}
        </VStack>
      </VStack>
    );
  }

  renderMobile(){
    return (
      <VStack pV={60} bgColor={ColorX.CSS("Grass")} fullWidth
        position="relative" mB={80}>
        <XDiv position="absolute" style={{
          top: 250, left: 0, marginLeft: -30, 
          zIndex: 1, opacity: 0.1, transform: "scale(1.5)"
        }} 
          height={387} fullWidth>
          <XImage source="/Images/home/sq2.svg" noResize width={70} height={70}
            position="absolute" style={{top: 10, left: 150}}/>
          <XImage source="/Images/home/sq1.svg" noResize width={210} height={210}
            position="absolute" style={{top: 60, left: 30}}/>
          <XImage source="/Images/home/sq1.svg" noResize width={210} height={210}
            position="absolute" style={{top: 60, left: 130}}/>
          <XImage source="/Images/home/sq2.svg" noResize width={70} height={70}
            position="absolute" style={{top: 250, left: 150}}/> 
        </XDiv>
        {this.renderSlideM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default observer(Compen);
